import { FileText, Rocket } from 'lucide-react';
import type { LibraryItem } from '@ideoz/core';
import { isPrototypeLibraryItem } from '@ideoz/core';
import { artifactTitle } from '../artifactMappers';

interface ArtifactRowProps {
  item: LibraryItem;
  isDeleting: boolean;
  onOpen: () => void;
  onDelete: (id: string) => void;
}

/** Dumb: a single library row — opens the panel (artifact) or workbench (prototype) on click. */
export function ArtifactRow({
  item,
  onOpen,
}: ArtifactRowProps): JSX.Element {
  const isPrototype = isPrototypeLibraryItem(item);
  const name = isPrototype ? item.title?.trim() || 'Prototype' : artifactTitle(item);
  const createdAt = item.createdAt;

  return (
    <li
      className="flex items-center gap-3 px-4 py-3 hover:bg-gray-50 dark:hover:bg-gray-750 cursor-pointer"
      onClick={onOpen}
    >
      {isPrototype ? (
        <Rocket className="w-5 h-5 text-primary-500 shrink-0" />
      ) : (
        <FileText className="w-5 h-5 text-primary-500 shrink-0" />
      )}
      <div className="flex-1 min-w-0">
        <p className="text-sm text-gray-800 dark:text-gray-100 truncate">{name}</p>
        {createdAt && (
          <p className="text-xs text-gray-400 dark:text-gray-500">
            {new Date(createdAt).toLocaleString()}
          </p>
        )}
      </div>
    </li>
  );
}
